import config from "../../config";
import {Session} from "./customer";
import {CustomerServiceError} from "./error";

export class Like {
  public type: string;
  public itemId: string;

  constructor(data: any) {
    this.type = data.type;
    this.itemId = data.itemId;
  }
}

export async function like(like: Like, session:Session): Promise<boolean> {
  const result = await fetch(`${config.customerServiceUrl}/customer/${session.customerId}/like`, {
    body: JSON.stringify(like),
    cache: 'no-cache',
    headers: {
      'content-type': 'application/json',
      'NY-SESSION-TOKEN': `${session.token}`,
    },
    method: 'POST',
  });

  if (!result.ok) {
    const json = await result.json();
    if (json.error) {
      throw new Error("[customer-service] error while liking: " + json.error)
    }
    throw new CustomerServiceError(json);
  }

  return true;
}

export async function dislike(like: Like, session:Session): Promise<boolean> {
  const result = await fetch(`${config.customerServiceUrl}/customer/${session.customerId}/dislike`, {
    body: JSON.stringify(like),
    cache: 'no-cache',
    headers: {
      'content-type': 'application/json',
      'NY-SESSION-TOKEN': `${session.token}`,
    },
    method: 'POST',
  });

  if (!result.ok) {
    const json = await result.json();
    if (json.error) {
      throw new Error("[customer-service] error while disliking: " + json.error)
    }
    throw new CustomerServiceError(json);
  }

  return true;
}

export async function getLikes(session:Session): Promise<Like[]> {
  const result = await fetch(`${config.customerServiceUrl}/customer/${session.customerId}/likes`, {
    body: JSON.stringify(like),
    cache: 'no-cache',
    headers: {
      'content-type': 'application/json',
      'NY-SESSION-TOKEN': `${session.token}`,
    },
    method: 'GET',
  });

  const json = await result.json();
  if (json.error) {
    throw new Error("[customer-service] error while disliking: " + json.error)
  }

  if (!result.ok) {
    throw new CustomerServiceError(json);
  }

  return (json as Array<any>).map(it => new Like(it));
}
